<template>
  <div>
    <div v-if="showMessage">
      {{ $nippets.replace('portfolio.nonews', 'name', artist.formatted_name) }}
    </div>
    <div class="news-matrix">
      <news-panel v-for="item in articles" :key="item.news_id" :item="item" v-on:click="goStory(item)" />
    </div>
    <news-popup :newsid="selectedId" v-model="showing" v-on:tag="handleTag" inportfolio />
  </div>
</template>

<script>
import NewsPopup from '@/views/news/NewsPopup.vue'
import NewsPanel from '@/views/news/NewsPanel.vue'
import apix from '@/api.js'

export default {
  components: {
    NewsPopup,
    NewsPanel
  },
  props: {
    artist: Object
  },
  data () {
    return {
      selectedId: '0',
      articles: [],
      showMessage: false,
      showing: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      if(this.artist.formatted_name) {
        this.showMessage = false
        console.log('init newsportfolio')
        let tag = this.$k.tagToUrl(this.artist.formatted_name)
        let res = await apix.get('news/artist/bytag/' + tag)
        this.articles = res.data
        this.$k.setMetatags("Lastest news and inspiring projects from " + this.artist.formatted_name,
                    "Here you will find the latest updates on " + this.artist.formatted_name + "'s recent work and upcoming projects.")
        if(this.articles.length < 1) {
          this.showMessage = true
        }
      }
    },
    handleTag(tag) {
      let t = '/news/tags/' + this.$k.tagToUrl(tag)
      this.$ixr.push(t)
    },
    handleClose () {
      this.showing = false
    },
    goStory(item) {
      this.selectedId = '' + item.news_id
    }
  },
  watch: {
    artist () {
      this.init()
    }
  }
}
</script>

<style>
.news-matrix{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height:400px;
}
</style>